<!--<c-footer>-->
<div>
  <span> &copy; 2024</span>
</div>
<!--</c-footer>-->